export default {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  setPlatformType (state, platformType) {
    state.platformType = platformType
  },
  closeSafeTips (state) {
    state.showSafeTips = false
  },
  setPlatformInfo (state, data) {
    state.platformInfo = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js